import { Pagination, Table, Tag } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import IconBack from '../../../../../../assets/Images/icons/icon-back';
import TemplateDesignService from '../../../../../../services/TemplateDesign.service';
import GlobalService from '../../../../../../services/Global.service';

export default function History() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    let { historyId } = useParams();
    const [historyInfo, setHistoryInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });
    const [imageUrl, setImageUrl] = useState();

    useEffect(() => {
        getHistoryDetail();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [historyId]);

    const getHistoryDetail = async (pageValue) => {
        try {
            const { data } = await TemplateDesignService.getHistoryDetail({
                historyId: historyId,
                p: pageValue.page ? pageValue.page : 1,
                ps: pageValue.pageSize ? pageValue.pageSize : 10,
            });
            setLoading(false);
            setHistoryInfo(data?.resultData || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        if (loading) {
            getHistoryDetail(currentPage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage.page, currentPage.pageSize]);

    const _getTagStatus = (e) => {
        switch (e.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {/* {i18n.language === 'en' ? e.statusEn : e.statusTh} */}
                        {e?.status} {e?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {/* {i18n.language === 'en' ? e.statusEn : e.statusTh} */}
                        {e?.status} {e?.latestPublishVersion}
                    </Tag>
                );
            default:
                return '-';
        }
    };

    const getImage = async (id) => {
        if (id) {
            try {
                const { data } = await GlobalService.getImage(id);
                if (data?.resultData?.imageId) {
                    setImageUrl(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    function decodeHtmlString(htmlString) {
        const parser = new DOMParser();
        const decodedString = parser.parseFromString(htmlString, 'text/html')
            .body.textContent;
        return decodedString;
    }

    const columns = [
        {
            title: <div>{t('Title')}</div>,
            dataIndex: lang === 'en' ? 'titleEn' : 'titleTh',
            key: 'title',
            width: '34%',
        },
        {
            title: <div>{t('OldData')}</div>,
            dataIndex: 'oldValue',
            key: 'oldValue',
            width: '33%',
            render: (value, row, index) => {
                switch (row.titleEn) {
                    case 'Logo':
                        return (
                            <>
                                {row?.oldValue?.length > 0 ? (
                                    row?.oldValue?.map((item) => {
                                        return item ? (
                                            lang === 'en' ? (
                                                <div className="px-2">
                                                    {
                                                        'The image has been deleted and cannot be displayed anymore.'
                                                    }
                                                </div>
                                            ) : (
                                                <div className="px-2">
                                                    {
                                                        'รูปภาพถูกลบแล้ว ไม่สามารถแสดงภาพเดิมได้'
                                                    }
                                                </div>
                                            )
                                        ) : (
                                            '-'
                                        );
                                    })
                                ) : (
                                    <div className="text-gray-600">-</div>
                                )}
                            </>
                        );
                    default:
                        return (
                            <>
                                {row?.oldValue?.length > 0 ? (
                                    row?.oldValue?.map((item) => {
                                        return (
                                            <p
                                                className="text-gray-600 whitespace-pre-line px-2"
                                                style={{
                                                    wordBreak: 'break-word',
                                                }}
                                            >
                                                {item !== 'null'
                                                    ? parse(item || '-')
                                                    : '-'}
                                            </p>
                                        );
                                    })
                                ) : (
                                    <div className="text-gray-600">-</div>
                                )}
                            </>
                        );
                }
            },
        },
        {
            title: <div>{t('CurrentData')}</div>,
            dataIndex: 'newValue',
            key: 'newValue',
            width: '33%',
            render: (value, row, index) => {
                switch (row.titleEn) {
                    case 'Logo':
                        return (
                            <>
                                {row?.newValue?.length > 0 ? (
                                    row?.newValue?.map((item) => {
                                        return (
                                            <img
                                                src={
                                                    getImage(item)
                                                        ? imageUrl
                                                        : imageUrl
                                                }
                                                className="object-cover w-auto h-20"
                                                alt={
                                                    lang === 'en'
                                                        ? 'Logo'
                                                        : 'โลโก้'
                                                }
                                            />
                                        );
                                    })
                                ) : (
                                    <div className="text-gray-600">-</div>
                                )}
                            </>
                        );
                    default:
                        return (
                            <>
                                {row?.newValue?.length > 0 ? (
                                    row?.newValue?.map((item) => {
                                        return (
                                            <p
                                                className="text-gray-600 whitespace-pre-line px-2"
                                                style={{
                                                    wordBreak: 'break-word',
                                                }}
                                            >
                                                {item !== 'null'
                                                    ? parse(item || '-')
                                                    : '-'}
                                            </p>
                                        );
                                    })
                                ) : (
                                    <div className="text-gray-600">-</div>
                                )}
                            </>
                        );
                }
            },
        },
    ];

    return (
        <div>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        // navigate(`/risk-assessment/${riskId}/view`);
                        navigate(-1);
                    }}
                >
                    <IconBack />
                </div>
                {t('History')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Consent Management')} /{' '}
                </span>
                <span className="text-sm text-gray-400">
                    {t('common.Consent')} /{' '}
                </span>

                <span> {t('History')} </span>
            </div>
            <div className="bg-white rounded-xl p-4 my-4">
                <div className="grid grid-cols-2 p-4">
                    <div className="col-span-1">
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Name')} :
                            </div>
                            <div
                                className="col-span-8 pr-2"
                                style={{ wordBreak: 'break-word' }}
                            >
                                {/* {historyInfo?.historyName || '-'} */}
                                {/* {consentNameEn} */}
                                {i18n.language === 'en'
                                    ? decodeHtmlString(
                                          historyInfo?.templateNameEn || '-'
                                      )
                                    : decodeHtmlString(
                                          historyInfo?.templateNameTh || '-'
                                      )}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Type')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.templateDesignType || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('LogDate')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.logDate
                                    ? moment(historyInfo?.logDate).format(
                                          'DD/MM/YYYY HH:mm'
                                      )
                                    : '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Update By')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.logBy || '-'}
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Version')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.version || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Status')} :
                            </div>
                            <div className="col-span-8">
                                <span>{_getTagStatus(historyInfo)}</span>
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Action')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.action ? (
                                    <Tag
                                        className="rounded-xl -my-1 text-center px-4 text-white"
                                        color="#7B67FB"
                                    >
                                        {i18n.language === 'en'
                                            ? historyInfo?.action
                                            : historyInfo?.action}
                                    </Tag>
                                ) : (
                                    <>-</>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl p-4">
                <Table
                    bordered
                    className="inbox_table"
                    dataSource={historyInfo?.historyDifResponse || []}
                    columns={columns}
                    pagination={false}
                />
            </div>
            <div className="w-full text-right mt-4">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={currentPage?.pageSize}
                    total={currentPage?.total || 1}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                    }}
                    showSizeChanger
                />
            </div>
        </div>
    );
}
